<script setup>
import MainLayout from '@/components/interface/main-layout.vue'
</script>

<template>
  <div class="home-page">
    <main-layout />
  </div>
</template>

<style lang="scss">
.home-page {
  height: 100%;
}
</style>
